const POST_DOCUMENT_XML = "POST_DOCUMENT_XML"
const POST_DOCUMENT_XML_SUCCESS = "POST_DOCUMENT_XML_SUCCESS"
const POST_DOCUMENT_XML_FAIL = "POST_DOCUMENT_XML_FAIL"

const BASE_ENDPOINT = '/Document/';
const initialValues = {
    loading: false,
    hasError: false,
    xmlLoaded: false
};

const documentXml = (state = initialValues, action) => {

    switch (action.type) {

        case POST_DOCUMENT_XML: {

            return {
                ...state,
                loading: true
            }

        }

        case POST_DOCUMENT_XML_SUCCESS: {

            return {
                ...state,
                data: action.payload.data,
                loading: false,
                xmlLoaded: true
            }

        }

        case POST_DOCUMENT_XML_FAIL: {

            return {
                ...state,
                loading: false,
                hasError: true,
            };
        }


        default: {
            return state;
        }

    }
};

export const postSendDocumentXml = (formData, dtId,countryId) => {
   
    return {
        type: POST_DOCUMENT_XML,
        payload: {
            request: {
                headers: {
                    contentType: 'multipart/form-data'
                },
                method: 'POST',
                url: `${BASE_ENDPOINT}Process/xml/${dtId}/${countryId}`,
                data: formData
            }
        }
    }
};

export default documentXml;